var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M30,7.5a30,30,0,0,0,30-30,30,30,0,0,0-30-30,30,30,0,0,0-30,30A30,30,0,0,0,30,7.5ZM20.508-31.992a2.8,2.8,0,0,1,3.973,0l5.508,5.508L35.5-31.992a2.8,2.8,0,0,1,3.973,0,2.811,2.811,0,0,1,0,3.973l-5.508,5.508L39.469-17a2.8,2.8,0,0,1,0,3.973,2.811,2.811,0,0,1-3.973,0l-5.508-5.508L24.48-13.031a2.8,2.8,0,0,1-3.973,0,2.811,2.811,0,0,1,0-3.973l5.508-5.508L20.508-28.02A2.8,2.8,0,0,1,20.508-31.992Z",
    transform: "translate(0.5 53)",
    fill: "#d30808",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.aa64fd28953e6878da1b15a827fa8c99.svg";
export { ForwardRef as ReactComponent };